<template>
  <div>
    <!-- search input -->
    <section id="knowledge-base-search">
      <b-card
          :style="{
          backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
        }"
          class="knowledge-base-bg text-center"
          no-body
      >
        <b-card-body class="card-body">
          <h2 class="text-primary">Cổng thông tin iTel</h2>
          <b-card-text class="mb-2">
            <span>Tìm kiếm phổ biến: </span>
            <span class="font-weight-bolder">Sổ tay iTel, Tin nội bộ ...</span>
          </b-card-text>

          <!-- form -->
          <b-form class="kb-search-input">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon"/>
              </b-input-group-prepend>
              <b-form-input
                  id="searchbar"
                  v-model="knowledgeBaseSearchQuery"
                  placeholder="nhập chủ đề...."
              />
            </b-input-group>
          </b-form>
          <!-- form -->
        </b-card-body>
      </b-card>
    </section>
    <!--/ search input -->

    <section id="knowledge-base-content">
      <!-- content -->
      <b-row class="kb-search-content-info match-height">
        <b-col
            v-for="item in filteredKB"
            :key="item.id"
            class="kb-search-content"
            md="4"
            sm="6"
        >
          <b-card
              :img-src="imgUrl"
              class="text-center cursor-pointer"
              img-top
              @click="() => onMoveTopic(item)"
          >
            <h4>{{ item.Name }}</h4>
            <!-- <b-card-text class="mt-1">
              {{ item.Name }}
            </b-card-text> -->
          </b-card>
        </b-col>
        <b-col v-show="!filteredKB.length" class="text-center" cols="12">
          <h4 class="mt-4">Search result not found!!</h4>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BForm,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import router from "@/router";

const imgUrl = require("@/assets/images/illustration/marketing.svg");
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
  },

  data() {
    return {
      knowledgeBaseSearchQuery: "",
      kb: [],
      imgUrl: imgUrl,
    };
  },
  computed: {
    filteredKB() {
      const knowledgeBaseSearchQueryLower =
          this.knowledgeBaseSearchQuery.toLowerCase();

      return this.kb.filter(
          (item) =>
              item.Name.toLowerCase().includes(knowledgeBaseSearchQueryLower) ||
              item.Name.toLowerCase().includes(knowledgeBaseSearchQueryLower)
      );
    },
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      useJwt
          .get("/news/categories")
          .then((response) => {
            if (response.data.code == 200) {
              this.kb = response.data.result.filter((item) => item.Level == 1);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lấy thông tin thành công",
                  icon: "AlertTriangleIcon",
                  variant: "success",
                },
              });
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },

    onMoveTopic(item) {
      router.push({
        name: "news-category-topics",
        params: {categoryId: item.ID, categoryName: item.Name},
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
